// src/ops/types/LambdaFailures.ts
var LambdaFailureService = /* @__PURE__ */ ((LambdaFailureService2) => {
  LambdaFailureService2["Main"] = "main";
  LambdaFailureService2["Booking"] = "booking";
  return LambdaFailureService2;
})(LambdaFailureService || {});

export {
  LambdaFailureService
};
